import "./About.css";
import robotImg from "./assets/meabt.png";

import m1 from "./assets/teacher_1.png"; 
import m2 from "./assets/teacher_2.png";
import m3 from "./assets/teacher_3.png";
import m4 from "./assets/teacher_4.png";

export default function About() {
  return (
    <div className="about-page">

      {/* HERO SECTION */}
      <section className="about-hero">
        <div className="hero-text">
          <h1>About Best Career Institute</h1>
          <p>Where Future-Ready Skills Meet Real Opportunities</p>
          <button>Get Started</button>
        </div>

        <img src={robotImg} className="hero-robot" alt="robot" />
      </section>

      {/* MISSION & VISION */}
      <section className="mission-vision">

        <div className="mv-card">
          <h3>🎯 Our Mission</h3>
          <p>
            To democratize quality education by blending expert-led teaching
            with practical, hands-on learning, helping learners build the
            skills that matter most in tech today.
          </p>
        </div>

        <div className="mv-card">
          <h3>🚀 Our Vision</h3>
          <p>
            To transform learners into confident professionals ready to seize
            opportunities in technology, data, and intelligent systems.
          </p>
        </div>

      </section>

      {/* MENTORS */}
      <section className="mentors">

        <h2>Why Choose BCI</h2>
        <p>Industry-Focused Learning for Modern Careers</p>

        <div className="mentor-grid">

          <div className="mentor-card">
            <img src={m1} />
            <h4>Anita Sharma</h4>
            <span>Google</span>
            <p>Full Stack Web Development</p>
          </div>

          <div className="mentor-card">
            <img src={m2} />
            <h4>Rohit Verma</h4>
            <span>Microsoft</span>
            <p>Python & Data Science</p>
          </div>

          <div className="mentor-card">
            <img src={m3} />
            <h4>Priya Mehta</h4>
            <span>OpenAI</span>
            <p>AI & Machine Learning</p>
          </div>

          <div className="mentor-card">
            <img src={m4} />
            <h4>Arjun Singh</h4>
            <span>Amazon</span>
            <p>DSA & Competitive Programming</p>
          </div>

        </div>

        <button className="view-btn">View All Mentors</button>

      </section>

      {/* STATS */}
      <section className="stats">

        <div className="stat-box">👨‍🎓 10,000+<br />Students Trained</div>
        <div className="stat-box">📘 6,000+<br />Courses Completed</div>
        <div className="stat-box">🎓 5,000+<br />Certificates Issued</div>
        <div className="stat-box">⏱ 50,000+<br />Hours of Content</div>

      </section>

    </div>
  );
}
